export default {
	Title: 'TỜ KHAI HÀNG HÓA NHẬP KHẨU (THÔNG QUAN)',
	CustomsDeclaration: 'Tờ khai hải quan',
	CustomsDeclarationTrash: 'Tờ khai đã xóa',
	AddDeclaration: 'Thêm tờ khai',
	EmptyStateTitle: 'Bạn chưa có tờ khai hải quan',
	EmptyStateDesc: 'Hãy thêm tờ khai hải quan để tiếp tục làm việc',
	EmptyStateTrashTitle: 'Bạn chưa có tờ khai đã xóa',
	ViewDeclaration: 'Xem tờ khai',
	PlaceholderSearchNew: 'Nhập Số tờ khai, Người xuất khẩu để tìm kiếm',
	Filter: 'Lọc tờ khai',
	DeclarationNo: 'Số tờ khai',
	DeclarationDate: 'Ngày tờ khai',
	ReceivedDate: 'Ngày nhận tờ khai',
	Exporter: 'Người xuất khẩu',
	BuyerTaxCode: 'Mã số thuế',
	BuyerAddress: 'Địa chỉ',
	TotalDeclarationAmount: 'Tổng trị giá hóa đơn',
	TotalDeclarationAmountExchange: 'Tổng trị giá hóa đơn quy đổi',
	TotalPreCustomsFee: 'Tổng chi phí trước HQ',
	TotalPreCustomsFeeExchange: 'Tổng chi phí trước HQ quy đổi',
	TotalTaxValue: 'Tổng trị giá tính thuế',
	TotalTaxAmount: 'Tổng tiền thuế',
	AmountAfterTax: 'Tổng tiền sau thuế',
	TotalAmount: 'Tổng tiền thanh toán quy đổi',
	CcyCode: 'Loại tiền',
	ExchangeRate: 'Tỷ giá',
	CompanyName: 'Công ty',
	CompanyTaxCode: 'MST Công ty',
	BranchName: 'Chi nhánh',
	BranchTax: 'MST chi nhánh',
	DepartmentName: 'Phòng ban',
	FirstDeclarationNo: 'Số tờ khai đầu tiên',
	CustomsName: 'Tên cơ quan Hải quan tiếp nhận tờ khai',
	CreatedDate: 'Ngày đăng ký',
	WaybillNumber: 'Số vận đơn',
	Importer: 'Người nhập khẩu',
	ImporterCode: 'Mã',
	ImporterName: 'Tên',
	ImporterAddress: 'Địa chỉ',
	ExporterCode: 'Mã',
	ExporterName: 'Tên',
	ExporterAddress: 'Địa chỉ',
	FeeHQ: 'Phí trước HQ quy đổi',
	Adjustment: 'Khoản điều chỉnh',
	Adjustment2: 'Khoản điều chỉnh 2',
	Adjustment3: 'Khoản điều chỉnh 3',
	Adjustment4: 'Khoản điều chỉnh 4',
	Adjustment5: 'Khoản điều chỉnh 5',
	TransportFee: 'Phí vận chuyển',
	InsuranceFees: 'Phí bảo hiểm',
	Tax: 'Tiền thuế',
	ImportTax: 'Thuế NK',
	VatTax: 'Thuế GTGT',
	TTDBTax: 'Thuế TTĐB',
	STT: 'STT',
	InventoryItemCode: 'Mã hàng',
	InventoryItemName: 'Tên hàng hóa',
	UnitName: 'Đơn vị tính',
	Quantity: 'Số lượng',
	UnitPrice: 'Đơn giá',
	Amount: 'Thành tiền',
	AmountExchange: 'Thành tiền quy đổi',
	TaxPrice: 'Trị giá tính thuế',
	ImportTaxTable: 'Thuế nhập khẩu',
	EnvironmentTax: 'Tiền thuế BVMT',
	EnvironmentTaxMaster: 'Thuế BVMT',
	DumpingTax: 'Thuế CBPG',
	TTDB: 'Thuế TTĐB',
	TS: 'TS',
	SumValue: 'Tổng trị giá HĐ: ',
	SumTaxBeforeFee: 'Tổng phí trước HQ: ',
	SumTax: 'Tổng tiền thuế: ',
	SumAmount: 'Tổng tiền thanh toán: ',
	SumValueTooltip: 'Tổng trị giá hóa đơn quy đổi',
	SumTaxBeforeFeeTooltip: 'Tổng phí trước hải quan quy đổi',
	SumTaxTooltip: 'Tổng tiền thuế quy đổi',
	SumAmountTooltip: 'Tổng tiền thanh toán quy đổi',
	FileError: 'Định dạng không được hỗ trợ',
	FileNotRead: 'Không đọc được tờ khai',
	FileDuplicate: 'Tờ khai trùng',
	FileRecommend: 'Vui lòng tải lên file xml, excel của tờ khai nhập khẩu thông quan',
	Period: 'Ngày tờ khai',
	FileCanDownload: 'Tải file *xls, *xlsx, *xml tờ khai hải quan hàng nhập khẩu (thông quan)',
	AlertPresentationXML:
		'Đây là bản thể hiện dựa trên file xml, excel của tờ khai. Nội dung này có thể không chính xác theo biểu mẫu của tờ khai thực tế.',
	RowSum: 'Tổng cộng',
	NotPermissionViewDeclaration: 'Bạn không có quyền xem tờ khai tại',
	NonDeclarationData:
		'Chưa có tờ khai hải quan hàng nhập khẩu (thông quan), vui lòng tải lên (*xls, *xlsx, *xml) tại đây.',
	WarningNonData: 'Lưu ý: Mỗi tờ khai hải quan tải lên sẽ bị trừ tài nguyên như hóa đơn.',
	TooltipViewDetail: 'Xem chi tiết tờ khai',
	WarningNonData: 'Lưu ý: Mỗi tờ khai hải quan tải lên sẽ bị trừ tài nguyên như hóa đơn.',
	Export: {
		MessageNotifiExportLimit: number =>
			`Dữ liệu xuất khẩu sẽ được lấy theo điều kiện lọc trên danh sách, <b class='font-bold'>tối đa ${number} tờ khai</b>.`
	},
	DeleteDeclarationTitle: 'Bạn muốn xóa tờ khai',
	DeleteDeclarationMess: 'Dữ liệu sau khi xóa vẫn có thể khôi phục lại tại mục "Tờ khai đã xóa".',
	DeleteDeclarationBatchMess: 'Bạn có chắc chắn muốn xóa các tờ khai đã chọn không?',
	DeleteProcessing: count => `Đang xử lý xóa ${count} tờ khai...`,
	DeleteSuccess: 'Đã xóa tờ khai thành công',
	DeletePartialSuccess: ({ successCount, totalCount, failCount }) =>
		`Đã xóa ${successCount}/${totalCount} tờ khai. ${failCount} tờ khai không thể xóa.`,
	DeleteExceedLimitTitle: 'Vượt quá số dòng',
	DeleteError: 'Xóa thất bại',
	RestoreError: 'Khôi phục thất bại',
	RestoreSuccess: 'Khôi phục thành công',
	MoveDeclaration: 'Điều chuyển tờ khai',
	blockedPopupTitle: 'Không thể điều chuyển tờ khai hải quan',
	blockedTransferToSpecialUnit:
		'Đơn vị nhận điều chuyển <strong>{unitName}</strong> là đơn vị có đặc thù kiểm tra hóa đơn của bên thứ 3 và <span style="color:#f5222d;font-weight:600">không có chức năng</span> nhận tờ khai hải quan.',
	blockedTransferToSpecialUnitNote: 'Vui lòng kiểm tra lại đơn vị nhận để tránh sai sót.',
	DeclarationListSelected: 'Danh sách tờ khai đã chọn',
	TotalDeclaration: 'Tổng số tờ khai',
	DeclarationSelected: count => `${count} tờ khai`,
	MaxDeclarationSelectWarning: maxNumber => `Bạn chỉ được chọn tối đa ${maxNumber} tờ khai.`,
	// BỔ SUNG: Translation keys cho combobox "Xem thông tin"
	ViewAllDeclarations: 'Xem tất cả tờ khai',
	ViewSelectedDeclarations: 'Chỉ xem tờ khai được chọn',
	DownloadOriginalDeclaration: 'Tải tờ khai gốc',
	DownloadingOriginalFile: 'Đang tải tờ khai gốc...'
};
